/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-deprecated */
/* eslint-disable unicorn/no-array-callback-reference */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable lingui/no-unlocalized-strings */
import { Binoculars, CircleNotch, Exam, MagicWand, PenNib } from "@phosphor-icons/react";
import { Badge, Button } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { useState } from "react";

import { toast } from "../hooks/use-toast";
import { changeTone } from "../services/openai/change-tone";
import { fixGrammar } from "../services/openai/fix-grammar";
import { improveWriting } from "../services/openai/improve-writing";
import { smartCheck } from "../services/openai/smart-check";
import { improveAllIssues, improveSingleIssue } from "../services/openai/smart-check-improve";
//import { useOpenAiStore } from "../stores/openai";

type Problem = {
  id: string;
  type: string;
  description: string;
  severity: "严重" | "一般" | "不严重";
  fixed?: boolean;
};

type SmartCheckResult = {
  problems: Problem[];
};

type Action = "check" | "improve" | "fix" | "tone";
type Mood = "casual" | "professional" | "confident" | "friendly";

type Props = {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  field?: {
    onChange: (value: string) => void;
  };
};

export const AiActions = ({ value, onChange, className, field }: Props) => {
  const [loading, setLoading] = useState<Action | "improveAll" | false>(false);
  const [checkResults, setCheckResults] = useState<Problem[] | null>(null);
  //const aiEnabled = useOpenAiStore((state) => !!state.apiKey);

  //if (!aiEnabled) return null;

  const onClick = async (action: Action, mood?: Mood) => {
    try {
      setLoading(action);
      setCheckResults(null);

      if (action === "check") {
        const response = await smartCheck(value);
        console.log("Smart check raw response:", response);

        try {
          if (!response) {
            console.error("Empty response received from smartCheck");
            throw new Error("空响应");
          }

          if (typeof response !== "string") {
            console.error("Unexpected response type:", typeof response);
            console.log("Response content:", response);
            throw new Error("响应格式错误");
          }

          // 尝试从响应中提取JSON
          let jsonStr = response;

          // 如果响应包含```，尝试提取其中的JSON部分
          if (response.includes("```")) {
            const matches = /```(?:json)?\s*({[\S\s]*?})\s*```/.exec(response);
            if (matches && matches[1]) {
              jsonStr = matches[1];
            }
          }

          // 确保字符串是一个有效的JSON对象
          if (!jsonStr.trim().startsWith("{")) {
            throw new Error("返回格式不是有效的JSON对象");
          }

          const parsedResult: SmartCheckResult = JSON.parse(jsonStr);

          if (!parsedResult.problems || !Array.isArray(parsedResult.problems)) {
            throw new Error("返回数据结构无效");
          }

          // 验证每个problem对象的结构
          const isValidProblem = (p: any): p is Problem => {
            return (
              typeof p.type === "string" &&
              typeof p.description === "string" &&
              ["严重", "一般", "不严重"].includes(p.severity)
            );
          };

          if (!parsedResult.problems.every(isValidProblem)) {
            throw new Error("问题数据格式不正确");
          }

          setCheckResults(parsedResult.problems);
          return;
        } catch (error) {
          console.error("JSON parsing error:", error);
          console.error("Failed response:", response);
          toast({
            variant: "error",
            title: "解析结果失败",
            description: `错误详情: ${(error as Error).message}`,
          });
        }
      }

      let result = value;
      if (action === "improve") result = await improveWriting(value);
      if (action === "fix") result = await fixGrammar(value);
      if (action === "tone" && mood) result = await changeTone(value, mood);

      onChange(result);
      field?.onChange(result);
    } catch (error) {
      console.error("Operation error:", error);
      toast({
        variant: "error",
        title: "抱歉，服务器返回错误。",
        description: (error as Error).message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImprove = async (problem?: Problem) => {
    try {
      event?.preventDefault?.();
      event?.stopPropagation?.();

      setLoading(problem ? "improve" : "improveAll");
      let result: string;

      if (!checkResults) {
        result = await improveWriting(value);
      } else if (problem) {
        // 处理单个问题优化
        console.log("开始处理单个问题优化:", {
          problemId: problem.id,
          type: problem.type,
          description: problem.description,
          targetText: value.slice(0, 100) + "...",
        });

        result = await improveSingleIssue(value, {
          id: problem.id,
          content: `${problem.type}：${problem.description}`,
        });

        console.log("单个问题优化结果:", {
          originalText: value.slice(0, 100) + "...",
          improvedText: result.slice(0, 100) + "...",
        });

        // 更新问题状态
        setCheckResults((prev) => {
          const updated =
            prev?.map((p) => (p.id === problem.id ? { ...p, fixed: true } : p)) ?? null;
          console.log("更新问题状态:", {
            problemId: problem.id,
            updatedResults: updated,
          });
          return updated;
        });
      } else {
        // 优化一键处理所有问题的逻辑
        const unfixedIssues = checkResults.filter((p) => !p.fixed);

        if (unfixedIssues.length === 0) {
          toast({
            title: "没有需要优化的问题",
            description: "所有问题已经修复完成",
          });
          return;
        }

        result = await improveAllIssues(
          value,
          unfixedIssues.map((p) => ({
            id: p.id,
            content: `${p.type}：${p.description}`,
          })),
        );

        // 更新所有问题状态为已修复
        setCheckResults((prev) => prev?.map((p) => ({ ...p, fixed: true })) ?? null);
      }

      console.log("准备更新文本内容");
      onChange(result);
      field?.onChange(result);
      console.log("文本内容更新完成");
    } catch (error) {
      console.error("优化过程出错:", error);
      console.error("错误详情:", {
        message: (error as Error).message,
        stack: (error as Error).stack,
      });

      toast({
        variant: "error",
        title: "优化失败",
        description: (error as Error).message,
      });
    } finally {
      console.log("优化流程结束，重置loading状态");
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div
        className={cn(
          "relative rounded bg-secondary-accent/50 p-3 outline outline-secondary-accent",
          "flex flex-wrap items-center justify-center gap-2",
          className,
        )}
      >
        <div className="absolute -left-5 z-10">
          <Badge
            outline
            variant="primary"
            className="-rotate-90 bg-background px-2 text-[10px] leading-[10px]"
          >
            <MagicWand size={10} className="mr-1" />
            AI
          </Badge>
        </div>

        <Button size="sm" variant="outline" disabled={!!loading} onClick={() => onClick("check")}>
          {loading === "check" ? <CircleNotch className="animate-spin" /> : <Binoculars />}
          <span className="ml-2 text-xs">智能检查</span>
        </Button>

        <Button size="sm" variant="outline" disabled={!!loading} onClick={() => onClick("improve")}>
          {loading === "improve" ? <CircleNotch className="animate-spin" /> : <PenNib />}
          <span className="ml-2 text-xs">一键优化</span>
        </Button>

        <Button size="sm" variant="outline" disabled={!!loading} onClick={() => onClick("fix")}>
          {loading === "fix" ? <CircleNotch className="animate-spin" /> : <Exam />}
          <span className="ml-2 text-xs">一键纠错</span>
        </Button>
      </div>

      {checkResults && (
        <div className="rounded border border-secondary-accent bg-secondary-accent/10 p-4">
          <div className="space-y-2">
            {checkResults.map((problem, index) => (
              <div
                key={index}
                className={cn(
                  "flex items-start gap-2 rounded p-2 text-sm",
                  "relative pl-4 before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:rounded-l",
                  "hover:text-muted-foreground transition-all hover:bg-background/90",
                  problem.severity === "严重" && "before:bg-red-500",
                  problem.severity === "一般" && "before:bg-yellow-500",
                  problem.severity === "不严重" && "before:bg-green-500",
                  problem.fixed && "opacity-50",
                )}
              >
                <p className="flex-1">
                  <span className="font-medium">{problem.type}</span>：{problem.description}
                  {problem.fixed && <span className="ml-2 text-green-500">(已修复)</span>}
                </p>
              </div>
            ))}
          </div>

          {checkResults.some((p) => !p.fixed) && (
            <div className="mt-4 flex justify-center gap-2">
              <Button
                variant="ghost"
                className="text-muted-foreground hover:text-foreground"
                onClick={() => {
                  setCheckResults(null);
                }}
              >
                忽略
              </Button>
              <Button
                variant="outline"
                className="w-full max-w-xs"
                disabled={!!loading}
                onClick={(event) => handleImprove()}
              >
                {loading === "improveAll" ? (
                  <CircleNotch className="mr-2 size-4 animate-spin" />
                ) : (
                  <MagicWand className="mr-2 size-4" />
                )}
                一键优化所有问题
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
